import { Observable } from 'rxjs';

import { SeamHealth } from 'app/model';
import { HealthData } from 'app/model/tools/health-data';
import { BaseApiService } from 'app/services/base-api.service';

class HealthService extends BaseApiService {
    public fetch(): Observable<HealthData[]> {
        return this.http.get<HealthData[]>(this.getAbsolutePath('health'));
    }

    public fetchSeam(): Observable<SeamHealth[]> {
        return this.http.get<SeamHealth[]>(this.getAbsolutePath('health/seam'));
    }
}

export const healthService = new HealthService();
